import { render, staticRenderFns } from "./AddBinding.vue?vue&type=template&id=36c5288e&scoped=true"
import script from "./AddBinding.vue?vue&type=script&lang=js"
export * from "./AddBinding.vue?vue&type=script&lang=js"
import style0 from "./AddBinding.vue?vue&type=style&index=0&id=36c5288e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5288e",
  null
  
)

export default component.exports